import React, { useCallback, useEffect, useRef, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Grid,
  Input,
  InputFile,
  Line,
  Picker,
  Row,
  SelectForm
} from 'components'
import useLoading from 'hooks/useLoading'
import { useForm } from 'react-hook-form'
import {
  ListaPorUsuarioAnexarDocumentoMensalGst,
  TipoDocumentoGst,
  TypeDocumentsGstServices
} from 'services/Supplier/WorkSafetyAdministration'
import { SPACING } from 'utils'
import * as yup from 'yup'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  FormDialog
} from './ModalNewGst.styles'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import Draggable from 'react-draggable'

interface IModalNewGst {
  showModal?: boolean
  handleModal?: () => void
  onSubmit?: (data: any) => void
  selectedContract: ListaPorUsuarioAnexarDocumentoMensalGst
}

export interface FormNewGST {
  dtCompetencia: Date
  txTipo: string
  dtAcesso: string
  txJust?: string
}

const schema = yup
  .object({
    txDescricao: yup.string().required('Informe o Tipo do documento')
  })
  .required()

const ModalNewGst: React.FC<IModalNewGst> = ({
  handleModal,
  showModal,
  onSubmit,
  selectedContract
}) => {
  const { setLoading, setMsgErro } = useLoading()
  const { handleSubmit, formState, control, reset } = useForm<FormNewGST>({
    resolver: yupResolver(schema)
  })

  const [typesDocument, setTypesDocument] = useState<
    TipoDocumentoGst[] | undefined
  >()

  const getTypesDoc = useCallback(async () => {
    setLoading('loading')
    try {
      const { data } = await TypeDocumentsGstServices().getAll()
      setTypesDocument(data)
      setLoading('idle')
    } catch (error: any) {
      setMsgErro(error)
      setLoading('error')
    }
  }, [])

  useEffect(() => {
    getTypesDoc()
  }, [getTypesDoc])

  const [filesUp, setFilesUp] = useState<File[] | undefined>()
  const [inputFileError, setInputFileError] = useState<string>('')

  const handleSubmitForm = (form) => {
    setInputFileError('')

    if (!filesUp) {
      setInputFileError('Você deve anexar um arquivo')
      return
    }

    onSubmit({ ...form, files: filesUp })
    reset()
    handleModal()
  }

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={showModal}
      onClose={handleModal}
      width={'lg'}
    >
      {/*
      <FormDialog
        onSubmit={handleSubmit((data) => {
          onSubmit({ ...data, files: filesUp })
          reset()
          handleModal()
        })}
      >
      */}
      <FormDialog
        onSubmit={(submitData) => {
          handleSubmit(handleSubmitForm)(submitData).then(() => {
            resetModalState(draggableReference)
          })
        }}
      >
        <Line />
        <DialogTitleStyled>Incluir Documento</DialogTitleStyled>
        <DialogContentStyled>
          <Grid
            gridCols="1fr 1.5fr 3fr 2fr"
            gridGap={`0 ${SPACING.spacing5}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              value={selectedContract?.cdContrato}
              label="Contrato"
              placeholder="Nº"
            />
            <Input
              value={selectedContract?.cdDocumento}
              label="CNPJ"
              marginLeft={SPACING.spacing15}
              marginRight={SPACING.spacing15}
              placeholder="Nº"
            />
            <Input
              value={selectedContract?.nmFornecedor}
              label="Fornecedor"
              placeholder="Nome do Fornecedor"
            />
          </Grid>
          <Grid
            gridCols="1fr 3fr 1fr 2fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Picker
              control={control}
              defaultValue={new Date()}
              formValue="dtCompetencia"
              label="Competência"
              placeholder="mm/aaaa"
            />
            <SelectForm
              control={control}
              errors={formState.errors}
              formValue="txDescricao"
              label="Tipo Documento"
              labelMenu="txTipo"
              valueMenu="idTipoDocumentoGst"
              listOptions={typesDocument}
              placeholder="Selecione"
              marginLeft={SPACING.spacing15}
              marginRight={SPACING.spacing15}
              required
            />
            <Picker
              defaultValue={new Date()}
              control={control}
              formValue="dtAcesso"
              label="Data Anexo"
              placeholder="dd/mm/aaaa"
            />
          </Grid>
          <Row alignItems="center">
            <InputFile
              placeholder="Selecione um ou mais arquivos."
              value={filesUp}
              onChange={(e) => setFilesUp(e)}
              widthInput="24em"
              error={inputFileError}
              required
            />
          </Row>
        </DialogContentStyled>
        <DialogActionsStyled>
          <Button
            text="Limpar"
            variantButton="text"
            onClick={() => reset()}
            marginBottom={SPACING.spacing20}
          />
          <Button
            text="Voltar"
            onClick={() => {
              handleModal()
              resetModalState(draggableReference)
              reset()
            }}
            variantButton="outlined"
            marginBottom={SPACING.spacing20}
          />
          <Button
            text="Enviar"
            type="submit"
            marginBottom={SPACING.spacing20}
            marginRight={SPACING.spacing20}
          />
        </DialogActionsStyled>
      </FormDialog>
    </DraggableDialog>
  )
}

export default ModalNewGst
